import React from "react";

import { Icon } from "@soluto-design/react";
import Link, { LinkProps } from "@soluto-design/link";

export interface BreadcrumbProps {
  links?: LinkProps[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ links = [] }) => {
  return (
    <nav aria-label="breadcrumb">
      <ul
        itemScope
        itemType="https://schema.org/BreadcrumbList"
        className="flex items-center gap-8 flex-wrap"
      >
        {links.map((link, i) => {
          const isLast = links.length - 1 === i;

          return (
            <li
              key={i}
              {...(isLast && { "aria-current": "page" })}
              itemProp="itemListElement"
              itemScope
              itemType="https://schema.org/ListItem"
              className="flex items-center gap-8 text-text-primary text-c100"
            >
              {!link.href ? (
                <span itemProp="name">{link.title}</span>
              ) : (
                <Link {...link} className="!no-underline !font-regular">
                  <span itemProp="name">{link.title}</span>
                </Link>
              )}
              {!isLast && (
                <Icon
                  icon="arrow-chevron--type-right"
                  className="text-[16px]"
                />
              )}
              <meta itemProp="position" content={i + 1} />
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Breadcrumb;
